<template>
    <div v-if="isOpen"
        class="tw:fixed tw:inset-0 tw:z-1055 tw:flex tw:items-end tw:sm:items-center tw:justify-center tw:p-2 tw:sm:p-4 tw:bg-black/50 tw:backdrop-blur-sm tw:transition-opacity"
        @click.self="handleBackdropClick" :aria-hidden="!isOpen" :aria-modal="isOpen ? 'true' : null">

        <!-- Contenedor principal del modal -->
        <div
            :class="['tw:w-full tw:bg-white tw:rounded-2xl tw:sm:rounded-3xl tw:shadow-2xl tw:overflow-hidden tw:flex tw:flex-col tw:max-h-[calc(100dvh-1rem)] tw:sm:max-h-[90dvh]', modalSizeClass]">

            <!-- Modal Header con soporte para Icono, Título y Descripción -->
            <slot name="header">
                <div
                    class="tw:px-4 tw:sm:px-6 tw:py-4 tw:bg-brand-background tw:text-white tw:flex tw:items-center tw:justify-between tw:gap-3 tw:shrink-0">
                    <div class="tw:flex tw:items-center tw:gap-3 tw:min-w-0">
                        <!-- Icono opcional -->
                        <div v-if="icon"
                            class="tw:shrink-0 tw:w-10 tw:h-10 tw:rounded-xl tw:bg-brand-primary/30 tw:flex tw:items-center tw:justify-center tw:text-brand-primary/80">
                            <i :class="[icon, 'tw:text-lg']"></i>
                        </div>
                        <div class="tw:min-w-0">
                            <h5 class="tw:text-base tw:font-bold tw:text-white tw:m-0 tw:break-words">{{ title }}</h5>
                            <!-- Descripción opcional debajo del título -->
                            <p v-if="description" class="tw:text-xs tw:text-slate-300 tw:m-0 tw:mt-0.5">{{ description
                            }}</p>
                        </div>
                    </div>
                    <button type="button"
                        class="tw:shrink-0 tw:text-slate-300 tw:hover:text-white tw:text-xl tw:transition-colors tw:bg-transparent tw:border-0 tw:cursor-pointer"
                        @click="close" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </slot>

            <!-- Modal Body (Scrolleable) -->
            <div class="tw:p-3 tw:sm:p-4 tw:bg-slate-50/50 tw:overflow-y-auto tw:overscroll-contain tw:grow tw:min-h-0">
                <slot name="body"></slot>
            </div>

            <!-- Modal Footer Slot (Estático / Fijo abajo) -->
            <div
                class="tw:px-4 tw:sm:px-6 tw:py-3.5 tw:bg-slate-50 tw:border-t tw:border-slate-200/80 tw:flex tw:flex-wrap tw:justify-end tw:gap-2 tw:sm:gap-3 tw:shrink-0">
                <slot name="footer">
                    <button type="button"
                        class="tw:px-4 tw:py-2 tw:bg-slate-200 tw:hover:bg-slate-300 tw:text-slate-800 tw:text-xs tw:font-semibold tw:rounded-xl tw:transition-colors tw:border-0 tw:cursor-pointer"
                        @click="close">
                        Cerrar
                    </button>
                </slot>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        modalName: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: 'Modal'
        },
        description: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'lg' // sm, md, lg, xl
        },
        staticBackdrop: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalSizeClass() {
            switch (this.size) {
                case 'sm': return 'tw:max-w-md';
                case 'md': return 'tw:max-w-lg';
                case 'xl': return 'tw:max-w-4xl';
                case 'xxl': return 'tw:max-w-6xl';
                default: return 'tw:max-w-2xl';
            }
        }
    },
    methods: {
        close() {
            this.$emit('close', this.modalName);
        },
        handleBackdropClick() {
            if (!this.staticBackdrop) {
                this.close();
            }
        }
    }
}
</script>